import React from "react";
import { cn } from "../../lib/utils";

const variantClasses = {
  default: "bg-primary text-primary-foreground shadow-soft hover:opacity-95",
  accent: "bg-accent text-accent-foreground shadow-soft hover:shadow-glow hover:-translate-y-0.5",
  hero: "text-accent-foreground shadow-elevated hover:shadow-glow hover:-translate-y-0.5",
  cream: "bg-cream text-ink border border-border hover:bg-card shadow-sm",
  destructive: "bg-destructive text-destructive-foreground shadow-sm hover:opacity-90",
  outline: "border-2 border-primary/20 bg-transparent text-foreground hover:border-accent hover:text-accent hover:bg-accent/5",
  outlineAccent: "border-2 border-accent text-accent bg-transparent hover:bg-accent hover:text-accent-foreground",
  secondary: "bg-secondary text-secondary-foreground hover:opacity-90",
  ghost: "rounded-md hover:bg-accent/10 hover:text-accent",
  link: "text-accent underline-offset-4 hover:underline rounded-none px-0",
};

const sizeClasses = {
  default: "h-11 px-6 py-2",
  sm: "h-9 px-4 text-xs",
  lg: "h-12 px-8 text-base",
  xl: "h-14 px-10 text-base",
  icon: "h-11 w-11",
};

export function Button({
  className,
  variant = "default",
  size = "default",
  type = "button",
  ...props
}) {
  const heroStyle = variant === "hero" ? { background: "var(--gradient-warm)" } : undefined;

  return (
    <button
      type={type}
      className={cn(
        "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-medium tracking-wide transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 active:scale-[0.97]",
        variantClasses[variant],
        sizeClasses[size],
        className
      )}
      style={heroStyle}
      {...props}
    />
  );
}

